import { Element, Transforms } from 'slate';
import { nanoid } from 'nanoid';

export const makeNodeId = () => nanoid(16);

export const assignIdRecursively = (node) => {
  if (Element.isElement(node) && !node.id) {
    node.id = makeNodeId();
    node.children.forEach(assignIdRecursively);
  }
};

export const withNodeId = () => (editor) => {
  const { apply, normalizeNode } = editor;

  editor.normalizeNode = (entry) => {
    const [node, path] = entry as [any, any[]];
    if (path.length === 1 && !node.id) {
      Transforms.setNodes(editor, { id: makeNodeId() }, { at: path });
    }
    normalizeNode(entry);
  };

  editor.apply = (operation) => {
    if (operation.type === 'insert_node') {
      assignIdRecursively(operation.node);
      return apply(operation);
    }

    if (operation.type === 'split_node') {
      operation.properties.id = makeNodeId();
      return apply(operation);
    }

    return apply(operation);
  };

  return editor;
};
